import { IOfferingCardProps, OfferingCard } from '../offering-card';

export interface IOfferingSmallCardProps
  extends Omit<IOfferingCardProps, 'className' | 'followModel'> {
  className?: string | { main?: string; follow?: string };
}

export function OfferingSmallCard(props: IOfferingSmallCardProps) {
  return <OfferingCard type="small" {...props} />;
}
